// Vuex connections module main file

import actions from './actions';
import mutations from './mutations';
import effects from './effects';
import types from './types';
import steps from './steps';
import statuses from './statuses';

const INITIAL_STATE = {
  filteringCriteria: {},
  historyList: {
    records: [],
    total: 0,
  },
  list: {
    records: [],
    total: 0,
    page: 1,
  },
  connectionsPerPage: 20,
  sortingDirection: 2,
};

const getters = {
  list: state => state.list,
  historyList: state => state.historyList,
  filteringCriteria: state => state.filteringCriteria,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
  modules: {
    effects,
    types,
    steps,
    statuses,
  },
};

export default Module;
